<template>
  <el-dialog title="分配设计" :visible.sync="visible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
    <el-form :model="ruleForm" ref="ruleForm" label-width="80px" class="name-ruleForm">
      <el-form-item label="标签：">
        <el-radio-group v-model="ruleForm.tagType" size="mini" style="display: block" @change="changeMode(ruleForm.tagType)">
          <el-radio-button label="default">手动选择</el-radio-button>
          <el-radio-button label="auto">自动选择</el-radio-button>
        </el-radio-group>
        <el-select v-if="ruleForm.tagType === 'default'" v-model="ruleForm.designer" placeholder="请选择" filterable>
          <el-option v-for="item in designerList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
        <el-select @change="changeRule" v-else v-model="ruleForm.tagRuleId" style="width: 100%" placeholder="请选择" filterable>
          <el-option v-for="item in tagRuleList" :key="item.id" :label="item.ruleName" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预览：" v-if="ruleForm.tagType === 'auto' && ruleForm.tagRuleId">
        <el-table :data="previewTable" border size="mini">
          <el-table-column prop="materialName" label="素材名称" width="140px">
            <template slot-scope="scope">
              {{ scope.row.materialName || "-" }}
            </template></el-table-column
          >
          <el-table-column prop="keyword" label="制作人关键字" width="140px">
            <template slot-scope="scope">
              {{ scope.row.keyword || "-" }}
            </template></el-table-column
          >
          <el-table-column prop="tag" label="制作人">
            <template slot-scope="scope">
              {{ scope.row.tag || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :disabled="isDisabled">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { distributionDesigner } from "@/api/material";
import { getMaterialTagRuleList, getPreviewTag, getTagPropertySelectList } from "@/api/property";
export default {
  data() {
    return {
      visible: false,
      ruleForm: {
        tagType: "default",
        designer: "",
        tagRuleId: "",
      },
      designerList: [],
      tagRuleList: [],
      previewTable: [],
      folderId: null,
      fileNames: [],
      idList: [],
    };
  },
  mounted() {},
  computed: {
    isDisabled() {
      let flag = false;
      if (this.ruleForm.tagType === "default" && !this.ruleForm.designer) {
        flag = true;
      } else if (this.ruleForm.tagType === "auto" && !this.ruleForm.tagRuleId) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.ruleForm.designer = "";
      this.$emit("clearOptionValue");
    },
    showModal(designer, folderId, idList, fileNames) {
      this.ruleForm.tagType = "default";
      getTagPropertySelectList({ type: 4 }).then((res) => {
        this.designerList = res.data;
      });
      this.visible = true;
      if (designer) {
        this.ruleForm.designer = Number(designer);
      }
      this.folderId = folderId;
      this.idList = idList;
      this.fileNames = fileNames;
      this.changeRule();
    },
    changeMode(flag) {
      if (flag === "auto") {
        getMaterialTagRuleList({
          type: 4,
        }).then((res) => {
          this.tagRuleList = res.data;
        });
      }
    },
    changeRule() {
      let list = [];
      this.fileNames.map((item) => {
        list.push({
          materialName: item,
          tagRuleId: this.ruleForm.tagRuleId,
        });
      });
      getPreviewTag(list).then((res) => {
        this.previewTable = res.data;
      });
    },
    handleSubmit() {
      let fileNames = [];
      this.fileNames.map((item, index) => {
        fileNames.push({
          fileName: this.idList[index],
          materialName: item,
        });
      });
      distributionDesigner({
        editType: 1,
        fileNames,
        ruleId: this.ruleForm.tagRuleId,
        tagType: this.ruleForm.tagType,
        designer: this.ruleForm.designer,
      }).then((res) => {
        if (res.code == "0000") {
          this.$emit("updateTags", this.folderId);
          this.$message.success("分配标签成功");
          this.visible = false;
          this.handleClose();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.name-ruleForm {
  /deep/ .el-form-item {
    margin-bottom: 12px !important;
  }
}
</style>
